export enum ChipListEnum {
  small = 'small',
  normal = 'normal'
}
